import { useEffect } from 'react';

import { useUser } from '@/lib/auth/useUser';

export const useCheckAuthenticated = (onUnauthenticatedAction: () => void) => {
  const { isAuthenticated, isInitialized } = useUser();

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      onUnauthenticatedAction();
    }
  }, [isAuthenticated, isInitialized, onUnauthenticatedAction]);
};
